import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, IconButton, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
/** The title of a view of a filter chip dropdown that the user opened from its list, with a button to go back to it */
export function FilterChipDropdownBackHeader(t0) {
  const $ = _c(10);
  const {
    title,
    backLabel,
    onBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: 0.5
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ChevronLeftIcon />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== backLabel || $[3] !== onBack) {
    t3 = <IconButton aria-label={backLabel} size="s" onClick={onBack}>{t2}</IconButton>;
    $[2] = backLabel;
    $[3] = onBack;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <Text variant="heading14">{title}</Text>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Stack direction="row" sx={t1}>{t3}{t4}</Stack>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}